import { render, staticRenderFns } from "./InputImageCpt.vue?vue&type=template&id=6886c154&"
import script from "./InputImageCpt.vue?vue&type=script&lang=ts&"
export * from "./InputImageCpt.vue?vue&type=script&lang=ts&"
import style0 from "./InputImageCpt.vue?vue&type=style&index=0&id=6886c154&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VFileInput,VImg})
